import { render, staticRenderFns } from "./StockMovementViewGlobal.vue?vue&type=template&id=672b184a"
import script from "./StockMovementViewGlobal.vue?vue&type=script&lang=js"
export * from "./StockMovementViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports